import { render, staticRenderFns } from "./shopProductType.vue?vue&type=template&id=ae90195e&scoped=true"
import script from "./shopProductType.vue?vue&type=script&lang=js"
export * from "./shopProductType.vue?vue&type=script&lang=js"
import style0 from "./shopProductType.vue?vue&type=style&index=0&id=ae90195e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae90195e",
  null
  
)

export default component.exports